import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-preferences",
  class: "description-list"
}
const _hoisted_2 = { class: "profile-buttons" }

import { computed } from 'vue'

  import { IUserProfile } from '@/types/user'
  import { languageLabels } from '@/utils/locales'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const language = computed(() =>
    props.user.language
      ? languageLabels[props.user.language]
      : languageLabels['en']
  )
  const fistDayOfWeek = computed(() => (props.user.weekm ? 'MONDAY' : 'SUNDAY'))
  const timezone = computed(() =>
    props.user.timezone ? props.user.timezone : 'Europe/Paris'
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", null, [
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.LANGUAGE')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(language)), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.TIMEZONE')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_unref(timezone)), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.FIRST_DAY_OF_WEEK')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$t(`user.PROFILE.${_unref(fistDayOfWeek)}`)), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.$t('user.PROFILE.UNITS.LABEL')) + ":", 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$t(
            `user.PROFILE.UNITS.${__props.user.imperial_units ? 'IMPERIAL' : 'METRIC'}`
          )), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/profile/edit/preferences')))
      }, _toDisplayString(_ctx.$t('user.PROFILE.EDIT_PREFERENCES')), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
      }, _toDisplayString(_ctx.$t('common.HOME')), 1)
    ])
  ]))
}
}

})